module.exports = __webpack_public_path__ + "img/23.69239da5.jpg";